import React from "react";

const WaFailure = () => {
  return (
    <div className="waCallbackPage" style={{ padding: "40px 24px", textAlign: "center", fontFamily: "sans-serif" }}>
      <h2 style={{ color: "#c00", marginBottom: "12px" }}>Connection failed or was cancelled</h2>
      <p style={{ color: "#555", marginBottom: "24px" }}>You can close this window and try connecting again from Connected Accounts.</p>
      <button
        type="button"
        onClick={() => window.close()}
        style={{
          padding: "10px 24px",
          background: "#666",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          fontSize: "14px"
        }}
      >
        Close window
      </button>
    </div>
  );
};

export default WaFailure;
export { WaFailure };
